import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import {ProfileIdentityContainer} from "../components/profile-identity.container";

export const ProfileIdentity: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Profile - Identity</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ProfileIdentityContainer />} />
      </Routes>
    </div>
  );
};
